import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getSectionsKeyValue from '../../services/section/getSectionKeyValue'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchSectionComboSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchSectionKeyValue () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const sectionCombo = yield call(getSectionsKeyValue, auth.token)
    yield put(fetchSectionComboSuccess({ data: sectionCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchSectionKeyValue () {
  yield takeLatest(combosActionTypes.FETCH_SECTION_KEY_VALUE, fetchSectionKeyValue)
}
